<template>
  <div>
    <v-row>
      <v-col cols="2" style="background-color: white; height: 90vh;">
        <!-- COMPONENTE DE MENU -->
         <UIIndicadores />
        <!-- END -->
      </v-col>
      <v-col>
        <div>
          <!-- COMPONENTE CONTIENE LOS TABS CON LAS SECCIONES POR CADA INDICADOR -->
          <TabSecciones 
            ref="tabIndicadores"
            v-if="getAIndicadores.length >= 1"
            :aDataTab="getAIndicadores[nIndicadorSelect]" 
            @onRegistroExitoso="onRegistroExitoso" 
            @onNuevo="onNuevo"
          />
          <!-- END -->
          <!-- PANTALLA DEFECTO SI NO ENCUENTRA INDICADORES -->
          <v-container v-else> 
            <v-row justify="center">
              <v-col cols="12" md="8" class="text-center" >
                <img src="@/assets/img/back-secciones-vacio.png" width="70%">
                <p>{{ $store.state.jsIdioma.oEquivalencias.msgSinIndicadores }}</p>
              </v-col>
            </v-row>
          </v-container>
          <!-- END -->
        </div>
        <!-- FORMULARIO PARA LA CREACIÓN DE INDICADOR -->
        <FormIndicador
          v-if="bShowFormIndicador"
          :key="keyForm"
          :sTableName="'Menu_Indicadores'"
          :sIdTable="'idMenu_Indicadores'"
          :titulo="$store.state.jsIdioma.oEquivalencias.cmpIndicador"
          :bMostrarFormulario = "bShowFormIndicador"
          :oDataFormularioAdicional="{ Tipo:1}"
          :bNuevo = "bNuevo"
          :idItem = "'idMenu_Indicadores'"
          :oData="oItem"
          @onCancelar="onCancelar"
          @onRegistroExitoso="onRegistroExitoso"
        />
        <!-- END -->

        <modal-mensaje-general
          v-model="oModalMensajeInput.bModalMensaje"
          :sMensaje="oModalMensajeInput.sMensaje"
          :nTipo="oModalMensajeInput.nTipo"
          :sNombreBotonConfirmar="oModalMensajeInput.sNombreBotonConfirmar"
        />

        <ModalCargando :sLabel="oCargandoData.sLabel" :nAvanceGeneral="oCargandoData.nAvanceGeneral" :bCargando="oCargandoData.bCargando"/>
      </v-col>
    </v-row>
    
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axiosServices from "@/services/axiosServices.js"
import FormIndicador from '@/views/Indicadores/FormIndicador.vue'
import TabSecciones from '@/components/Indicadores/tabsSecciones.vue'
import ModalCargando from '@/components/ModalCargando.vue';
import UIIndicadores from '@/components/general/menu/UIIndicadores.vue'

export default {
  name:"navconfig",
  props: {
    sIdModule: {
      type: String,
    },
  },
  components: {
    FormIndicador,
    TabSecciones,
    ModalCargando,
    UIIndicadores
  },
  data() {
    return {
      keyForm : 0,
      bShowFormIndicador:false,
      bNuevo:true,
      oItem:{},
      nIndicadorSelect: 0,
      bMenuEstado: false,
      oModalMensajeInput: {
        bModalMensaje: false,
        sMensaje: "",
        nTipo: 2,
        sNombreBotonConfirmar: 'Aceptar'
      },
      oCargandoData:{
        bCargando:false,
        sLabel:"Sincronizando Reportes...",
        nAvanceGeneral:35
      },
    }
  },
  async mounted() {
    //sincronizamos los reportes
    this.onCargaInicial();
    // this.oCargandoData.bCargando=true;
    // await axiosServices.postConfiguration( "/indicadores/onSincronizarReportes",{},true,"");
    // this.oCargandoData.bCargando=false;
  },
  methods: {
    onCargaInicial(){
      this.$store.dispatch('indicadores/setAPermisos', `sTable=Menu_Indicadores&nPerfil=${this.$store.state.idPerfil}`)
      this.$store.dispatch('indicadores/setAIndicadores', { estado:"inicial" , params: `nIdPerfil=${this.$store.state.idPerfil}`})
    },
    onIndicador(val){
      this.nIndicadorSelect = val
      this.bMenuEstado = true
    },
    onNuevo(){
      if(this.getAIndicadores.length < 5){
        this.bMenuEstado = true
        this.bShowFormIndicador=true
        this.keyForm+=1
      }else{
        if(!this.bNuevo) {
          this.$store.dispatch("indicadores/save_nuevo_indicador", false);
          return;
        }
        this.oModalMensajeInput.bModalMensaje = true
        this.oModalMensajeInput.sMensaje = this.$store.state.jsIdioma.oEquivalencias.msgMaximoIndicadoresCreados
        this.$store.dispatch("indicadores/save_nuevo_indicador", false);
      }
    },
    onEditarIndicador(obInd){
      this.bShowFormIndicador=true
      this.bNuevo = false
      this.keyForm+=1
      this.oItem = {
        idMenu_Indicadores : obInd.idIndicador,
        Nombre_menu : obInd.indicador,
        Tipo: 1,
        Icono: obInd.icono
      }
    },
    onCancelar(){
      this.bMenuEstado = false
      this.bShowFormIndicador=false
      this.oItem = {}
      this.bNuevo = true
      this.$store.dispatch('indicadores/save_seleccionadoEditar', {}) // Limpiamos el item seleccionado para editar
      this.$store.dispatch('indicadores/save_seleccionadoEstado', {}) // Limpiamos el item seleccionado para activar o desactivar
    },
    async onRegistroExitoso(oRegistro){
      this.bShowFormIndicador=false
      this.oItem = {}
      this.bNuevo = true
      if(oRegistro){
        await axiosServices.getConfiguration("/indicadores/validarnuevo", true, `nIdModule=${this.sIdModule}&nIdPerfil=${this.$store.state.idPerfil}&sIndicador=${oRegistro.Nombre_menu}`)
        if(this.getAIndicadores.length >= 4){
          this.$swal({
            timer: 3000,
            icon:`success`,
            title:`Registro exitoso. Ya se han creado el máximo de indicadores permitidos`,
            showConfirmButton: false
          })
        }
      }
      await this.onCargaInicial();
      await this.$store.dispatch('indicadores/setAIndicadores', { estado:"actualizar" , params: `nIdPerfil=${this.$store.state.idPerfil}`})
      this.$refs.tabIndicadores.onValidacionPowerBI();
    },
    async onOcultar(obj){
      let estadoCampo = 0
      obj.estado === '1' ? estadoCampo = 0 : estadoCampo = 1
      let oBody = {
        "sTable"  : "Menu_Indicadores",
        "sCampo"  : "estado",
        "sValor"  : estadoCampo,
        "aCampos" : {
          "idMenu_Indicadores": obj.idIndicador
        }
      }
      const axiosChange = await axiosServices.putConfiguration('/pGrids_changeCampo', oBody , true , `sTable=Menu_Indicadores` )
      if(axiosChange.nStatusCode === 200 && !axiosChange.aData ) {
        this.valor = !this.valor
        this.$store.dispatch('notificaciones/SetTitulo', this.$store.state.jsIdioma.oEquivalencias.ttlError)
        this.$store.dispatch('notificaciones/SetTimeout', 4000)
        this.$store.dispatch('notificaciones/SetColor','errornotify')
        this.$store.dispatch('notificaciones/SetMensaje','No se pudo realizar el cambio')
      } else {
        this.$store.dispatch('notificaciones/SetColor','successnotify')
        this.$store.dispatch('notificaciones/SetTimeout', 4000)
        this.$store.dispatch('notificaciones/SetTitulo', this.$store.state.jsIdioma.oEquivalencias.ttlNotificacionSuccess)
        this.$store.dispatch('notificaciones/SetMensaje', this.$store.state.jsIdioma.oEquivalencias.lblAccionCompletada)
      }
      this.$store.dispatch('notificaciones/SetPosition', 'top')
      this.$store.dispatch('notificaciones/ShowNotificacion',true); 
      this.$store.dispatch('indicadores/setAIndicadores', { estado:"actualizar" , params: `nIdPerfil=${this.$store.state.idPerfil}`})
    }
  },
  watch: {
    sIdModule(sNewValue, sOldValue) {
      if (sNewValue !== sOldValue) {
        this.getMenuModules();
      }
    },
    getNuevoIndicador() {
      if(this.getNuevoIndicador) {        
        this.onNuevo()
      }
    },
    bShowFormIndicador() {
      this.$store.dispatch('indicadores/save_nuevo_indicador', this.bShowFormIndicador)
    },
    getSeleccionado() {      
      this.onIndicador(this.getSeleccionado);
    },
    getSeleccionadoEditar: {
      handler() {
        if(Object.entries(this.getSeleccionadoEditar).length > 0) { // validamos que esto no se encuentre vacio
          this.onEditarIndicador(this.getSeleccionadoEditar)
        }
      }, deep: true
    },
    getSeleccionadoEstado: {
      handler() {
        if(Object.entries(this.getSeleccionadoEstado).length > 0) { // validamos que esto no se encuentre vacio
          this.onOcultar(this.getSeleccionadoEstado)
        }
      }, deep: true
    }
  },
  computed:{
    ...mapGetters('indicadores',['getAIndicadores', 'getBCargando', 'getAPermisos', 'getBCargandoConfigGrid', 'getNuevoIndicador', 'getSeleccionado', 'getSeleccionadoEditar', 'getSeleccionadoEstado' ]),
  }
}
</script>
<style lang="scss" scoped>
.item-inactivo{
  opacity: 0.6;
}
.item-submenu-editar{
  min-height: 10px;
  max-height: 45px;
}
.sub-btn-editar{
  text-transform:none;
  letter-spacing:normal;
  max-height: 45px;
}
</style>